import Component from './Battery.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconBattery', Component);
  },
};
